module.exports.ENV = {
    integration: 'int',
    preprod: 'preprod',
    prod: 'prod',
    local: 'local',
};
